<servicerapport-accordion-panel>
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">

      <mat-expansion-panel-header>
        <mat-panel-title>Måleroplysninger</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row">
        <div class="col-xs-12">
          @if (data) {
            <table>
              @for (oplysning of oplysninger; track oplysning) {
                <tr>
                  <td>{{ oplysning.key }}</td>
                  <td>: <strong>{{ oplysning.value }}</strong></td>
                </tr>
              }
            </table>
          }
        </div>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</servicerapport-accordion-panel>
